import styled from 'styled-components';

export const SummaryContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 20px;
`;

export const SummaryBox = styled.div`
  background: white;
  padding: 25px 30px;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 15px;
    bottom: 15px;
    width: 10px;
    background-image: radial-gradient(
      circle at 5px 10px,
      #ededed 4px,
      white 4px
    );
    background-size: 10px 20px;
    background-repeat: repeat-y;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 15px;
    bottom: 15px;
    width: 10px;
    background-image: radial-gradient(
      circle at 5px 10px,
      #ededed 4px,
      white 4px
    );
    background-size: 10px 20px;
    background-repeat: repeat-y;
  }
`;

export const SummaryItem = styled.div`
  border-bottom: 2px dotted #e1e1e1;
  padding: 2px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #4b5563;
  &:not(:last-child) {
    border-bottom: 2px dotted #e1e1e1;
  }
`;

export const Divider = styled.div`
  border: none;
  border-top: 2px dashed #d1d5db;
  margin: 20px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  color: #000;
`;
